<template>
  <div class="d-flex flex-wrap px-3 px-md-0 mx-md-n2 mb-2">
    <VCol
      v-for="(category,index) in categoriesWithQuestions"
      :key="index"
      class="pa-1 pa-md-2"
      cols="6"
      lg="3"
      xl="2"
    >
      <VCard
        outlined
        @click="select(category)"
      >
        <VCardText class="text-center pa-3 pa-md-4">
          <span class="primary--text link-dotted body-1">{{ category.name }}</span>
        </VCardText>
      </VCard>
    </VCol>
  </div>
</template>

<script>
export default {
  name: 'VacancyWizardSubCategories',
  props: {
    categories: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  computed: {
    categoriesWithQuestions() {
      return this.categories.filter((cat) => cat.questions.length > 0);
    },
  },
  methods: {
    select(category) {
      this.$emit('select', category);
    },
  },

};
</script>

<style lang="scss" scoped>
.link-dotted {
  font-size: 18px;
  line-height: 22px;
  font-weight: 300;
}
</style>
